import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';

import SpaClassesV1 from './SpaClasses';
import { SpaClassesV2 } from './v2';

type SpaClassesVersionProps = {
  language: string;
};

export const SpaClassesVersion: FC<SpaClassesVersionProps> = (props) => {
  const isV2 = useFeatureIsOn('feature.ecom2');
  if (isV2) return <SpaClassesV2 {...props} />;
  return <SpaClassesV1 {...(props as any)} />;
};
